import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/education/index.scss';
import { DocumentsSearchWidget } from '../widgets/documents-search-widget';
import { initSearchInput } from '../utils/search-input';
import { initPermissionRequest } from '../widgets/permission-request';
import {
  initEducationPageTabsNav,
  scrollActiveEducationTabIntoView,
} from '../utils/education-page-tabs';

const EDUCATION_DOCUMENTS_SEARCH_ID = 'educationDocumentsSearch';
const EDUCATION_PERMISSION_OPEN_EVENT = 'stc:education-permission-open';

function bindEducationPermissionOpenTriggers(root?: ParentNode): void {
  const scope = root ?? document;
  scope.querySelectorAll<HTMLElement>('[data-education-permission-open]').forEach((trigger) => {
    if (trigger.dataset.educationPermissionBound === 'true') return;
    trigger.dataset.educationPermissionBound = 'true';
    trigger.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent(EDUCATION_PERMISSION_OPEN_EVENT));
    });
  });
}

registerPageInit('education-management', (root) => {
  initEducationPageTabsNav();
  initSearchInput(root, { inputId: EDUCATION_DOCUMENTS_SEARCH_ID });

  new DocumentsSearchWidget(
    EDUCATION_DOCUMENTS_SEARCH_ID,
    'inner-educationDocsSearchResult',
    'educationAccordionSearchResult',
    'educationDocsSearchResultSummary',
    'educationDocsSearchResult-no-matches',
    'educationDocumentsAccordionGroup',
    3,
    400,
    'education',
  ).init();

  initPermissionRequest(root, { launcher: 'float' });
  bindEducationPermissionOpenTriggers(root);
  scrollActiveEducationTabIntoView(root);
});
